import { TEMPLATE_FAVORITE_LISTING_TYPE } from '@utils/constants';

export const templateFavoritesQueryKeys = {
  ids: () => ['favorite-listing-ids', TEMPLATE_FAVORITE_LISTING_TYPE] as const,
  count: () =>
    ['favorite-listing-count', TEMPLATE_FAVORITE_LISTING_TYPE] as const,
  templatesRoot: () => ['favorite-templates'] as const,
  templates: (page: number, pageSize: number) =>
    ['favorite-templates', page, pageSize] as const,
  infiniteTemplates: () => ['favorite-templates', 'infinite'] as const,
};
